import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({ baseURL: `${API_BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pilot_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('pilot_token');
      localStorage.removeItem('pilot_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
